// @ts-ignore
/* eslint-disable */
import { removeSessionCookie } from '@/utils/cookie';
import wrapperRequest from '@/utils/request';
import { request } from '@umijs/max';

export async function currentUser(options?: { [key: string]: any }) {
  return wrapperRequest<API.CurrentUser>('/erpanlam-hrm/me/info', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function userPermissions(options?: { [key: string]: any }) {
  return wrapperRequest<API.UserPermissions>('/erpanlam-hrm/me/permissions', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function outLogin(options?: { [key: string]: any }) {
  // removeSessionCookie();
  return wrapperRequest<any>('/erpanlam-hrm/me/logout', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return wrapperRequest<API.LoginResult>('/erpanlam-hrm/auth/login', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

export async function forgotPassword(body: any, options?: { [key: string]: any }) {
  return wrapperRequest<any>('/erpanlam-hrm/auth/forgot-password', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

export async function resetPassword(body: any, options?: { [key: string]: any }) {
  return wrapperRequest<any>('/erpanlam-hrm/auth/reset-password', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any }
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
